import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import Time from "../components/time";
import { Link, useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Bill_add_vehicle = () => {
  useAuthRedirect();
  const { basis, vcode, billNo } = useParams();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const canEntry = hasPermission("Hire Bill Generation", "entry");

  useEffect(() => {
    setLoading(true);
    axios.get(`https://rfs2.infraconsoft.net.in/api/bill_addSpare?vcode=${vcode}&branch_code=${branch}`)
      .then((response) => {
        if (response.data && response.data.addSpare) {
          setData(response.data.addSpare);
          setFilteredData(response.data.addSpare);
        } else {
          console.warn("No vehicles found in response.");
        }
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [vcode, branch]);

  const cumulativeData = useMemo(() => {
    let amt = 0;
    let totamt = 0;

    return data.map((item) => {
        amt = item.sfissuesDetail_issuedQuantity * item.sfIssuesDetail_price;
        totamt += amt;

      return {
        amount: amt,
        totalAmt: totamt,
      };
    });
  }, [data])

  
  const handleVehicleSelection = (vehicleId) => {
    console.log("🟢 Selected Vehicle ID:", vehicleId); 
  
    setSelectedItems((prev) =>
      prev.includes(vehicleId)
        ? prev.filter((id) => id !== vehicleId)
        : [...prev, vehicleId]
    );
  
    console.log("✅ Updated Selected Items:", [...selectedItems, vehicleId]); 
  };
  
  const handleSubmit = async () => {
    console.log("🚀 Sending to backend:", selectedItems);
  
    if (selectedItems.length === 0) {
      Swal.fire("No Selection", "Please select at least one item!", "warning");
      return;
    }
  
    try {
      Swal.fire({
                        title: "Submitting...",
                        text: "Please wait while we process your request.",
                        allowOutsideClick: false,
                        didOpen: () => {
                          Swal.showLoading();
                        },
                      });
                      
      const response = await axios.post("https://rfs2.infraconsoft.net.in/api/add_spare", {
        selectedItems,
        vcode,
        billNo,
        branch
      });
  
      console.log("✅ Backend Response:", response.data);
  
      // Show success alert & redirect
      Swal.fire({
        title: "Success!",
        text: "Billing Approved!",
        icon: "success",
        confirmButtonText: "OK"
      }).then(() => {
        navigate(`/generate_bill/${vcode}/${basis}`);

      });
  
      setSelectedItems([]); 
  
    } catch (error) {
      console.error("❌ Error in handleSubmit:", error.response?.data || error.message);
  
      // Show error alert
      Swal.fire({
        title: "Error!",
        text: error.response?.data?.message || "Something went wrong!",
        icon: "error",
        confirmButtonText: "OK"
      });
    }
  };
  
  
  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.vehicle &&
          item.vehicle.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.battery_code &&
          item.battery_code
            .toLowerCase()
            .includes(e.target.value.toLowerCase())) ||
        (item.battery_type &&
          item.battery_type
            .toLowerCase()
            .includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
  };

  if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                                        <h2 className="add-txt">Hire Vehicle Spares Details</h2>
                                        <Link to={`/generate_bill/${vcode}/${basis}`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                      </div>
          <Time />
        </section>

        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by vehicleName" value={searchTerm} onChange={handleSearch} className="search-input"/>
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
              <th>S.No</th>
                <th>Vehicle number</th>
                <th>Vehicle Status</th>
                <th>Date</th>
                <th>Material Code</th>
                <th>Material Name</th>
                <th>UOM</th>
                <th>Material Qty</th>
                <th>Material Price</th>
                <th>Material Amount</th>
                <th>Total Amount</th>
                <th>Bill</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="15" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : data.length > 0 ? (
                data.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.vehicleno}</td>
                      <td>Hire</td>                     
                      <td>{new Date(item.logoutTime).toLocaleDateString("en-GB")}</td> 
                      <td>{item.sfissuesDetail_itemCode}</td>
                      <td>{item.sfissuesDetail_itemName}</td>
                      <td>{item.sfissuesDetail_uom}</td>
                      <td>{item.sfissuesDetail_issuedQuantity}</td>
                      <td>{item.sfIssuesDetail_price}</td>                     
                      <td>{cumulativeData[index]?.amount?.toLocaleString("en-IN",{ minimumFractionDigits: 2 }) || "0.00"}</td>
                      <td>{cumulativeData[index]?.totalAmt?.toLocaleString("en-IN",{ minimumFractionDigits: 2 }) || "0.00"}</td>
                      <td><input type="checkbox" checked={selectedItems.includes(item.fld_issiueid)} 
                      onChange={() => handleVehicleSelection(item.fld_issiueid)}/>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="15">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="btn-cls">
        <button type="button" className="submit-btn" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default Bill_add_vehicle;
